<template>

<div v-cloak>

  <div class="grid grid--middle push--bottom">
    <div class="grid__item two-thirds portable--one-whole">

      <div class="page-heading">
        <h1 class="page-heading__title">{{ $_('smart_qr_codes') }}</h1>
      </div>

    </div><div class="grid__item one-third portable--one-whole" v-show="client.beaconstac_org_id">

      <label for="daterange_start" style="display: block; padding-bottom: 6px;">{{ $_('set_date_range') }}:</label>
      <date-range-picker v-model="dateRange" :ranges="ranges" :locale-data="dateRangeLocale">
        <template v-slot:input="picker">
          {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
        </template>
      </date-range-picker>

    </div>
  </div>

  <div class="grid" v-show="qrCodes.length">

    <div class="grid__item one-third lap--one-half palm--one-whole">

      <div class="form">
        <div class="form__field">
          <select name="campaign" class="field field--select" v-model="selectedCampaign">
            <option :value="0">{{ $_('all_campaigns') }}</option>
            <option v-for="option in availableCampaigns" :value="option" :key="option.id + option.name">{{ option.name }}</option>
          </select>
        </div>
      </div>

    </div><div class="grid__item one-quarter lap--one-half palm--one-whole">

      <div class="button-group button-group--stackable push-half--bottom float--left">
        <button @click="exportCsv()" class="button button--small button--light">{{ $_('export') }}</button>
      </div>

    </div>
  </div>

  <div v-show="!loading">

    <div class="push-half--bottom" v-show="backLink">
      <a :href="backLink" class="button button--small button--cranberry">{{ $_('back_to_my_prospects') }}</a>
    </div>

    <div class="form__line push--top flush--bottom" v-show="error">
      <div class="form__field">
        <div class="parsley-error">{{ error }}</div>
      </div>
    </div>

    <table class="table table--striped table--word-break table--stackable milli flush--bottom" v-show="paginatedQrCodes.length">
      <thead>
      <tr>
        <th>{{ $_('date_time') }}</th>
        <th>{{ $_('qr_campaign_name') }}</th>
        <th>{{ $_('location') }}</th>
        <!-- <th>{{ $_('device') }}</th> -->
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in paginatedQrCodes" v-bind:key="index + item.id + item.fingerprint + item.dateTime" valign="top">
          <td :data-title="$_('date_time')" v-bind:title="item.date.format('lll')">{{ item.date.format('lll') }}</td>
          <td :data-title="$_('qr_campaign_name')">
            <div class="truncate" v-bind:title="item.name" style="width: auto;">{{ item.name }}</div>
          </td>
          <td :data-title="$_('location')" v-bind:title="item.location">{{ item.location }}</td>
          <!-- <td :data-title="$_('device')">
            <div class="truncate" v-bind:title="item.device" style="width: auto; max-width: 300px;">{{ item.device }}</div>
          </td> -->
        </tr>
      </tbody>
    </table>

    <div class="grid push--top" v-show="filteredQrCodes.length">
      <div class="grid__item one-half portable--one-whole">

        <div class="button-group push-half--bottom">
          <button v-for="n in displayPages" :key="'page-' + n" class="button button--small button--light" :class="{ 'button--primary': currentPage === n, 'button--disabled': n === '...' }" :disabled="n === '...'" @click="changePage(n)">{{ n }}</button>
        </div>

        <div class="push-half--bottom" v-show="backLink">
          <a :href="backLink" class="button button--small button--cranberry">{{ $_('back_to_my_prospects') }}</a>
        </div>

      </div><div class="grid__item one-half portable--one-whole text--right color-grey-dark">
        {{ $_('total_qr_code_scans') }}: {{ filteredQrCodes.length }}
        <!-- ({{ $_('unique_qr_code_scans') }}: {{ getUniqueScans(filteredQrCodes).length }}) -->
        <p class="text--right color-grey-dark text--small" v-if="timestamp">
					{{ $_('data_is_current') }}
					{{ timestamp.format('LT') }} ({{ timestamp.format('MMM D') }})
				</p>
      </div>
    </div>

    <p v-show="client.beaconstac_org_id && !filteredQrCodes.length" class="flush--bottom">{{ $_('no_qr_code_scans') }}</p>
    <p v-show="!client.beaconstac_org_id" class="flush--bottom">{{ $_('no_qr_code') }} <a href="mailto:go@DRMG.ca" target="_blank">go@DRMG.ca</a>.</p>

  </div>

  <p v-show="loading" class="flush--bottom"><i class="fa fa-spin fa-spinner"></i></p>

</div>

</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { exportToCsv } from './utils';

const startDate = new URL(location.href).searchParams.get('date_start');
const endDate = new URL(location.href).searchParams.get('date_end');

export default {
  name: 'beaconstac',
  components: { DateRangePicker },
  data () {
    return {
      user: window.user,
      client: window.client,
      dateRange: {
        startDate: startDate ? moment(startDate).toDate() : moment().subtract(1, 'week').toDate(),
        endDate: endDate ? moment(endDate).toDate() : moment().toDate(),
      },
      backLink: new URL(location.href).searchParams.get('back_link'),
      ranges: {},
      dateRangeLocale: {
        format: 'yyyy-mm-dd',
        separator: ' - ',
        applyLabel: this.$_('submit'),
        cancelLabel: this.$_('cancel'),
      },
      selectedCampaign: 0,
      loading: false,
      qrCodes: [],
      error: null,
      timestamp: null,
      pageSize: 25,
      currentPage: 1,
    }
  },
  mounted () {
    this.ranges[this.$_('today')] = [moment().toDate(), moment().toDate()];
    this.ranges[this.$_('yesterday')] = [moment().subtract(1, 'day').toDate(), moment().subtract(1, 'day').toDate()];
    this.ranges[this.$_('last_week')] = [moment().subtract(1, 'week').toDate(), moment().toDate()];
    this.ranges[this.$_('last_month')] = [moment().subtract(1, 'month').toDate(), moment().toDate()];
    this.getQrCodes();
  },
  computed: {
    availableCampaigns: function() {
      let campaigns = this.qrCodes.filter((v,i,a) => a.findIndex(t => (t.id === v.id)) === i).sort((a, b) => a.id > b.id);
      return campaigns.map(c => ({ name: c.name, id: c.id }));
    },
    filteredQrCodes: function() {
      // const campaigns = this.selectedCampaigns.map(c => c.id); // support multiple selected campaigns
      return this.qrCodes.filter(q => this.selectedCampaign !== 0 ? this.selectedCampaign.id === q.id : true);
    },
    totalPages: function() {
      return Math.ceil(this.filteredQrCodes.length / this.pageSize);
    },
    displayPages: function() {
      let pages = [];
      if (!this.totalPages) return pages;
      let neighbours = 3;
      for (let index = 1; index <= this.totalPages; index++) {
        let prev = pages[pages.length - 1];
        if (index === 1 || index === this.totalPages) {
          pages.push(index);
        } else if (Math.abs(index - this.currentPage) <= neighbours) {
          pages.push(index);
        } else if (prev !== '...') {
          pages.push('...');
        }
      }
      return pages;
    },
    indexStart: function() {
      return (this.currentPage - 1) * this.pageSize;
    },
    indexEnd: function() {
      return this.indexStart + this.pageSize;
    },
    paginatedQrCodes: function() {
      return this.filteredQrCodes.slice(this.indexStart, this.indexEnd);
    }
  },
  watch: {
    dateRange: function(newRange, oldRange) {
      // update start/end date query params
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set('date_start', moment(newRange.startDate).format('YYYY-MM-DD'));
      searchParams.set('date_end', moment(newRange.endDate).format('YYYY-MM-DD'));
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
      window.history.pushState({ path: newurl }, '', newurl);
      // get scans
      this.getQrCodes();
    }
  },
  methods: {
    formatDate: function(d) {
      return moment(d).format('YYYY-MM-DD');
    },
    getUniqueScans: function(scans) {
      return [...new Set(scans.map(q => q.userId))];
    },
    getQrCodes: function() {
      var self = this;
      if (!self.client.beaconstac_org_id) return;
      self.loading = true;
      const date_start = moment(self.dateRange.startDate).format('YYYY-MM-DD');
      const date_end = moment(self.dateRange.endDate).add(1, 'days').format('YYYY-MM-DD');
      this.$http.get(`/api/v1/${self.client.id}/qr?date_start=${date_start}&date_end=${date_end}`).then(
        function(response) {
          self.qrCodes = response.data.scans.map(p => {
            const formatted = {
              date: moment.utc(p.time).local(),
              dateTime: moment.utc(p.time).format(),
              id: p.beacon,
              name: p.beacon_name,
              url: p.beacon_url,
              userId: p.fingerprint,
              ip: p.ip,
              device: p.user_agent,
              city: p.city,
              postal: p.postal,
              province: p.province,
              country: p.country,
              latitude: p.latitude,
              longitude: p.longitude,
              location: [p.city, p.postal, p.province].filter(a => a !== '').join(', '),
            };
            return formatted;
          }).sort((a, b) => a.date.format('x') > b.date.format('x'));
          self.loading = false;
          self.timestamp = response.data.timestamp ? moment.unix(response.data.timestamp) : null;
        },
        function(error) {
          console.error(error);
          self.error = error;
          self.loading = false;
        }
      )
    },
    exportCsv: function() {
      const rows = this.filteredQrCodes.map(q => {
        const a = {...q};
        delete a.date;
        delete a.location;
        return a;
      })
      exportToCsv(`${client.company_name}_QR_scans_${moment().format('YYYY-MM-DD')}.csv`, rows);
    },
    changePage: function(n) {
      this.currentPage = n;
    }
  }
}

</script>

<style lang="scss">

.daterangepicker {
  border-radius: 0;

  .calendars {
    display: grid;
    grid-template-columns: auto auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/Beaconstac.vue